// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const e = {
  production: true, // Set to true before the production build and deployment
  serverUrl: '',
  rootUrl: '',
  loginUrl: '/login',
  assets: '../../../assets',
  wsEndpoint: '',
  wsReconnectInterval: 2000,
  refreshInterval: 60000,
  stage: 'mauprod',
  apiServiceId: 'ns10c5ruxf',
  accessKeyId: 'AKIAVRUVPHSPCY6HKEMI',
  secretAccessKey: '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',
  column_name: 'Subclass Id',
  custom_field: 'subclass_id',
  prod_labels: ['Division', 'Department', 'Category', 'Class'],
  bourneUrl: '',
  region: 'us-east-1',
  cognito: {
    userPoolId: 'us-east-1_4N0H7K3kP',
    userPoolClientId: '382r6h6bhg178cnegv1k9u5m2m',
    oauthDomain: 'sizeo-mauprod.auth.us-east-1.amazoncognito.com',
    redirectSignIn: [
      'http://localhost:4200/',
      'https://dmhr7dqiuiamh.cloudfront.net/',
      'https://mau-prod.sizeo.ai/'
    ],
    redirectSignOut: [
      'http://localhost:4200/logout/',
      'https://dmhr7dqiuiamh.cloudfront.net/logout/',
      'https://mau-prod.sizeo.ai/logout/'
    ]
  },
  appsync: {
    endpoint: 'https://4kbhwa33tbg2hhi646qljc7ise.appsync-api.us-east-1.amazonaws.com/graphql'
  }
}

export const environment = e

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
